import 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { styled } from '../../theme/utils.js';
import '../../theme/types.js';

const Wrapper = styled("div", {});

export { Wrapper };
